import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import AssessmentIcon from '@material-ui/icons/Assessment';
import AvTimerIcon from '@material-ui/icons/AvTimer';
import CommentIcon from '@material-ui/icons/Comment';
import HelpIcon from '@material-ui/icons/Help';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import PassIcon from '@material-ui/icons/Loop';
import QueuePlayNextIcon from '@material-ui/icons/QueuePlayNext';
import RestoreIcon from '@material-ui/icons/Restore';
import SearchIcon from '@material-ui/icons/Search';
import StoreIcon from '@material-ui/icons/Store';
import { BiPurchaseTag } from 'react-icons/bi';
import { CgLastpass, CgLogIn, CgLogOut } from 'react-icons/cg';
import { FaFileInvoiceDollar, FaStore } from 'react-icons/fa';
import { FcDebt } from 'react-icons/fc';
import TouchAppIcon from '@material-ui/icons/TouchApp';
import TransferWithinAStationIcon from '@material-ui/icons/TransferWithinAStation';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import SendIcon from '@material-ui/icons/Send';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import PagesIcon from '@material-ui/icons/Pages';
import ViewCarouselIcon from '@material-ui/icons/ViewCarousel';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import BuildIcon from '@material-ui/icons/Build';
import { colors, Typography } from '@material-ui/core';
import Label from 'src/components/Label';
import { getUser } from 'src/utils/Common';
import axios from 'src/utils/axios';
import ChatIcon from '@material-ui/icons/ChatOutlined';
import DashboardIcon from '@material-ui/icons/Dashboard';
import HomeIcon from '@material-ui/icons/HomeOutlined';
import FormatListBulletedIcon from '@material-ui/icons/ImportContacts';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import PersonIcon from '@material-ui/icons/PersonOutlined';
import ReportIcon from '@material-ui/icons/Report';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { GoDeviceMobile, GoLocation } from 'react-icons/go';
import { RiMessage2Line } from 'react-icons/ri';

export const getYorumAdet = () => {
  return sessionStorage.getItem('YorumAdet') || null;
};

export const getIslerAdet = () => {
  return sessionStorage.getItem('IsAdet') || null;
};

export const setIslerAdet = Adet => {
  sessionStorage.removeItem('IsAdet');
  sessionStorage.setItem('IsAdet', Adet);
};

// //////////////// UYARI ///////////////////////

export const getUyariAdet = () => {
  return sessionStorage.getItem('UyariAdet') || null;
};

export const setUyariAdet = Adet => {
  sessionStorage.removeItem('UyariAdet');
  sessionStorage.setItem('UyariAdet', Adet);
};

// //////////////// SATIŞ ADET ///////////////////////

export const getSatisAdet = () => {
  return sessionStorage.getItem('SatisAdet') || null;
};
export const setSatisAdet = Adet => {
  sessionStorage.removeItem('SatisAdet');
  sessionStorage.setItem('SatisAdet', Adet);
};

// //////////////// MALZEME IHTIYAÇ ///////////////////////

export const setMalzemeIhtiyacAdet = Adet => {
  sessionStorage.removeItem('MalzemeIhtiyacAdet');
  sessionStorage.setItem('MalzemeIhtiyacAdet', Adet);
};
export const getPassCount = Type => {
  const user = getUser();
  axios
    .get('getPassCount/' + user.ServiceShopId + '/' + Type)
    .then(response => {
      sessionStorage.setItem(`Pass${  Type}`, response.data);
    })
    .catch(error => {
      sessionStorage.setItem(`Pass${  Type}`, 0);
    });

  if (sessionStorage.getItem(`Pass${  Type}`) !== '0') {
    return (
      <Label color={colors.red[500]} shape="rounded">
        {sessionStorage.getItem('Pass' + Type) || null}
           </Label>)
  } else {
    return '';
  }
};

export const getPassCountMain = Type => {
  if (sessionStorage.getItem(`Pass${  Type}`) !== '0') {
    return (
      <Label color={colors.red[500]} shape="rounded">
        {sessionStorage.getItem('Pass' + Type) || null}
           </Label>)
  } else {
    return (
      <Label color={colors.green[500]} shape="rounded">
        {sessionStorage.getItem('Pass' + Type) || null}
           </Label>)

  }
};

// ////////////// YORUM /////////////////////////////

export const setYorumAdet = Adet => {
  sessionStorage.removeItem('YorumAdet');
  sessionStorage.setItem('YorumAdet', Adet);
};
